import { Dayjs } from 'dayjs';

class TimesheetError extends Error {
  message: string;

  status: string;

  comments: string;

  date: Dayjs;

  constructor(message: string, status: string, comments: string, date: Dayjs) {
    super('Timesheet Error');
    this.message = message;
    this.status = status;
    this.comments = comments;
    this.date = date;
  }
}

export default TimesheetError;
